import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [devLink, setDevLink] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      if (data.dev_token) setDevLink(`/sifre-sifirla?token=${data.dev_token}`);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Şifreni sıfırla" subtitle="E-posta adresini gir, sıfırlama bağlantısı gönderelim.">
      {sent ? (
        <div data-testid="forgot-success" className="text-ink-2 leading-relaxed">
          <p>Eğer bu e-posta kayıtlıysa bir sıfırlama bağlantısı gönderildi.</p>
          {devLink && (
            <p className="mt-4 text-sm">Geliştirme modu bağlantısı:
              <Link to={devLink} className="text-terra underline ml-1" data-testid="dev-reset-link">Şifreyi sıfırla</Link>
            </p>
          )}
          <Link to="/giris"><Button className="mt-6 bg-terra hover:bg-terra-hover text-white rounded-lg h-11 px-6">Girişe dön</Button></Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email">E-posta</Label>
            <Input id="email" data-testid="forgot-email" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} className="mt-1 h-11" />
          </div>
          <Button type="submit" disabled={loading} data-testid="forgot-submit"
            className="w-full h-11 bg-terra hover:bg-terra-hover text-white rounded-lg">
            {loading ? "Gönderiliyor..." : "Bağlantı Gönder"}
          </Button>
          <p className="text-sm text-center"><Link to="/giris" className="text-terra hover:underline">Girişe dön</Link></p>
        </form>
      )}
    </AuthShell>
  );
}
